module.exports = __webpack_public_path__ + "media/images/icons/loading-fde7b811737dcdc7d083ec8b5e09b901.svg";